export const createShareLink = (pathname) => {
  return `https://discover.lanl.gov${pathname}`;
};
